import React from 'react';
import { BarLoader } from 'react-spinners';
import styled from 'styled-components';

const LoaderStyles = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh; /* Adjust this value as needed */
    background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999; /* Ensure it appears above other content */
`;

const Loader = ({ loading }) => {
    return (
        <LoaderStyles className="loader">
            <BarLoader color="#36D7B7" loading={loading} size={50} />
        </LoaderStyles>
    );
};

export default Loader;
